module.exports = __webpack_public_path__ + "static/media/plus.b8b66264.svg";